import { render, staticRenderFns } from "./CamaraCevice.vue?vue&type=template&id=770bf06c&"
import script from "./CamaraCevice.vue?vue&type=script&lang=ts&"
export * from "./CamaraCevice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports